import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import { connect } from "react-redux";
// import { IntlProvider } from "react-intl";
// import IntlGlobalProvider from "../lngProvider/IntlGlobalProvider";
// import Header from "../components/header";
import asyncComponent from "../util/asyncComponent";
import "../assets/style";

class App extends Component {
	componentWillMount() {
	
	}

	render() {

		const { match } = this.props;
		console.log(match);
		return (
		
			<div className="wrapper">
				{/* <Header></Header> */}
				<Switch>
					<Route exact path={`${match.url}/`} component={asyncComponent(() => import("./view/notfound"))} />
					<Route exact path={`${match.url}notfound`} component={asyncComponent(() => import("./view/notfound"))} />
					<Route exact path={`${match.url}expired`} component={asyncComponent(() => import("./view/expired"))} />
					<Route exact path={`${match.url}:hash`} component={asyncComponent(() => import("./view/coupon_detail"))} />
					{/* <Route component={asyncComponent(() => import("./view/coupon_detail"))} /> */}
				</Switch>
			</div>	
				
		);
	}
}

export default connect()(App);
